/* RESPONSIBLE TEAM: team-tickets-1 */
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default EmbercomBaseSerializer.extend({
  collectionKey: 'blocked_users',
});
